import { render, staticRenderFns } from "./AccidentStatistics.vue?vue&type=template&id=04c6901c&scoped=true&"
import script from "./AccidentStatistics.vue?vue&type=script&lang=js&"
export * from "./AccidentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AccidentStatistics.vue?vue&type=style&index=0&id=04c6901c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c6901c",
  null
  
)

export default component.exports